import { render, staticRenderFns } from "./ProfitLossDrillThrough.vue?vue&type=template&id=5354bbd0&scoped=true&"
import script from "./ProfitLossDrillThrough.vue?vue&type=script&lang=js&"
export * from "./ProfitLossDrillThrough.vue?vue&type=script&lang=js&"
import style0 from "./ProfitLossDrillThrough.vue?vue&type=style&index=0&id=5354bbd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5354bbd0",
  null
  
)

export default component.exports